// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedDisablementStateChange } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/DisablementStateChange';
import { DisablementHistoryEntry } from '../../../../utils/LedgerApiClientV2';
import TemplateContract from '../../../../utils/TemplateContract';
import { useTemplateHistory } from '../../useTemplateHistory';

const toDisablementHistoryEntry = (
  contract: TemplateContract<ExecutedDisablementStateChange>,
): DisablementHistoryEntry => ({
  contractId: contract.contractId,
  createdAt: contract.createdAt,
  instrumentId: contract.payload.instrumentId.id,
  action: contract.payload.action,
  actor: contract.payload.actor,
});

const useAllDisablementHistory = (): {
  data: DisablementHistoryEntry[];
  isLoading: boolean;
} => {
  const history = useTemplateHistory(ExecutedDisablementStateChange);
  const data = history.data.map(toDisablementHistoryEntry);
  return { data, isLoading: history.isLoading };
};

export default useAllDisablementHistory;
